module.exports = __webpack_public_path__ + "img/86c0f12.png";